<template>
  <CDialog
    @close="emit('close')"
    @outer-click="emit('close')"
    :show="show"
    :title="$t('filter')"
    body-class="!overflow-visible"
    :custom-class="'max-w-[500px]'"
  >
    <div class="flex-y-center p-5 flex-col justify-center text-center">
      <div class="w-full grid md:grid-cols-2 gap-2 mb-4">
        <FGroup :label="$t('select_category')">
          <FSelect
            :options="categories"
            v-model="values.category"
            value-key="value"
            label-key="label"
          />
        </FGroup>
        <FGroup :label="$t('select_status')">
          <FSelect
            :options="statuses"
            v-model="values.status"
            value-key="value"
            label-key="label"
          />
        </FGroup>
        <FGroup :label="$t('select_type')">
          <FSelect
            :options="types"
            v-model="values.type"
            value-key="value"
            label-key="label"
          />
        </FGroup>
        <FGroup :label="$t('date')">
          <FDatePicker v-model="values.date" range :max-date="new Date()" />
        </FGroup>
      </div>
      <CButton :text="$t('filter')" @click="filter" />
    </div>
  </CDialog>
</template>

<script setup lang="ts">
import CDialog from "@/components/Common/Dialog/CDialog.vue";
import CButton from "@/components/Common/CButton.vue";
import { unref } from "vue";
import FSelect from "@/components/Form/Select/FSelect.vue";
import FDatePicker from "@/components/Form/Date/FDatePicker.vue";
import { reactive } from "@vue/runtime-core";
import { useI18n } from "vue-i18n";
import FGroup from "@/components/Form/FGroup.vue";

interface Props {
  show: boolean;
  form?: {
    status: string;
    type: string;
    category: string;
    date: string;
  };
}
const props = defineProps<Props>();
const { values } = unref(props?.form);
const emit = defineEmits<{
  (e: "close"): void;
  (e: "filterTransactions"): void;
}>();

const { t } = useI18n();

const categories = reactive([
  {
    label: t("all"),
    value: "all",
  },
  {
    label: "CR",
    value: "cr",
  },
  {
    label: "DR",
    value: "dr",
  },
]);
const statuses = reactive([
  {
    label: t("all"),
    value: "all",
  },
  {
    label: t("failed"),
    value: "failed",
  },
  {
    label: t("pending"),
    value: "pending",
  },
  {
    label: t("success"),
    value: "success",
  },
]);
const types = reactive([
  {
    label: t("all"),
    value: "all",
  },
  {
    label: t("balance"),
    value: "balance",
  },
  {
    label: t("plan"),
    value: "plan",
  },
  {
    label: t("trade"),
    value: "trade",
  },
]);

const filter = () => {
  emit("filterTransactions");
};
</script>

<style scoped></style>
